module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.props) ? _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer__top"
  }, [_c('div', {
    staticClass: "footer__container"
  }, [_c('div', {
    staticClass: "footer__top-row"
  }, [_c('div', {
    staticClass: "footer__item"
  }, [_c('a', {
    staticClass: "footer__patient-login",
    attrs: {
      "href": _vm.props.acf.links.login,
      "target": "_blank"
    }
  }, [_c('span', [_vm._v("Patient Login")])])]), _c('div', {
    staticClass: "footer__item"
  }, [_c('div', {
    staticClass: "footer__icons"
  }, _vm._l((_vm.props.acf.social_links), function(icon, i) {
    return (icon.label != "phone") ? _c('a', {
      staticClass: "footer__icon",
      attrs: {
        "href": icon.href,
        "target": "_blank"
      }
    }, [_c('Icon', {
      class: "footer__" + icon.label,
      attrs: {
        "name": icon.icon
      }
    })], 1) : _vm._e()
  }), 0)]), _c('div', {
    staticClass: "footer__item"
  }, [_c('a', {
    staticClass: "footer__rewards",
    attrs: {
      "href": _vm.props.acf.links.rewards,
      "target": "_blank"
    }
  }, [_c('span', [_vm._v("Rewards Center")]), _c('Icon', {
    staticClass: "footer__rewards-icon",
    attrs: {
      "name": "arrow"
    }
  })], 1)])])])]), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "min-width": "200px"
    }
  }, [_c('div', {
    staticClass: "footer__bottom"
  }, [_vm._m(0), _c('div', {
    staticClass: "footer__bottom--third"
  }, [_c('a', {
    staticClass: "footer__phone",
    attrs: {
      "href": _vm.props.acf.social_links[0].href
    }
  }, [_vm._v("Call or Text Us Anytime"), _c('br'), _vm._v("585. 742. 1050")]), _c('a', {
    staticClass: "footer__address",
    attrs: {
      "href": _vm.props.acf.address.href,
      "target": "_blank"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.address.text)
    }
  }), _c('div', {
    staticClass: "footer_address2"
  }, [(_vm.props.acf.address_new.text) ? _c('a', {
    staticClass: "footer__address",
    attrs: {
      "href": _vm.props.acf.address_new.href,
      "target": "_blank"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.address_new.text)
    }
  }) : _vm._e()])]), _vm._m(1)]), _c('div', {
    staticClass: "footer__roostergrin"
  }, [_vm._v("Powered by RoosterGrin"), _c('div', {
    staticClass: "footer__adminuse"
  }, [_c('router-link', {
    attrs: {
      "to": "/admin-links"
    }
  }, [_vm._v("Admin use only")])], 1), _c('div', {
    staticClass: "footer__floatingcontact"
  }, [_c('router-link', {
    attrs: {
      "to": "/contact-us"
    }
  }, [_vm._v("Ask A Question")])], 1)])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer__bottom--third"
  }, [_c('img', {
    staticClass: "footer__bottom--hipaa",
    attrs: {
      "src": "https://cpwk.cloud/wp-content/uploads/2019/04/pcihipaa_logo.png",
      "alt": "Certified HIPAA Compliance Provided by PCIHIPAA"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer__bottom--third"
  }, [_c('a', {
    staticClass: "footer__badge",
    attrs: {
      "href": "https://interpret.cyracom.com/",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "footer__svg",
    staticStyle: {
      "width": "200px",
      "height": "124px"
    },
    attrs: {
      "src": "https://www.mattiacioortho.com/wp-content/uploads/cyracom-white.png",
      "alt": "Cyracom interpretation services"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06f769bd","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/footer/footer.pug
// module id = 667
// module chunks = 1